const IconDialpad = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="4" r="1.5" fill="currentColor" />
      <circle cx="12" cy="4" r="1.5" fill="currentColor" />
      <circle cx="18" cy="4" r="1.5" fill="currentColor" />
      <circle cx="6" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="12" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="18" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="6" cy="15" r="1.5" fill="currentColor" />
      <circle cx="12" cy="15" r="1.5" fill="currentColor" />
      <circle cx="18" cy="15" r="1.5" fill="currentColor" />
      <circle cx="12" cy="20.5" r="1.5" fill="currentColor" />
    </svg>
  )
}

export default IconDialpad
